import { render, staticRenderFns } from "./SOVDetailedamdIndia.vue?vue&type=template&id=1a8a49be&scoped=true"
import script from "./SOVDetailedamdIndia.vue?vue&type=script&lang=js"
export * from "./SOVDetailedamdIndia.vue?vue&type=script&lang=js"
import style0 from "./SOVDetailedamdIndia.vue?vue&type=style&index=0&id=1a8a49be&prod&lang=css"
import style1 from "./SOVDetailedamdIndia.vue?vue&type=style&index=1&id=1a8a49be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a49be",
  null
  
)

export default component.exports